<template>
  <div class="deviceAllContainer">
    <router-view></router-view>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.deviceAllContainer{
  height: 100%;
}
</style>
